import { DateTime } from 'luxon';
import { CalendarDate } from '@internationalized/date';

const FORMATS = [
  'M/d/yyyy',
  'M-d-yyyy',
  'M/d/yy',
  'M-d-yy',
  'LLL d, yyyy',
  'LLLL d, yyyy',
] as const;

export function parseInput(raw: string): CalendarDate | null {
  if (typeof raw !== 'string') return null;
  const s = raw.trim();
  if (!s) return null;
  for (const fmt of FORMATS) {
    const dt = DateTime.fromFormat(s, fmt, { zone: 'utc' });
    if (dt.isValid) {
      return new CalendarDate(dt.year, dt.month, dt.day);
    }
  }
  return null;
}
